// MarketWatchLoading.jsx — Loading screen shown while waiting for market data to initialize
// Login and demo mode are handled by App.js — this only shows "Initializing..." or broker message

import React from 'react';

function MarketWatchLoading({ themeCtx, retryCount, brokerMessage }) {
  const { t } = themeCtx;

  // If broker is not logged in, show a clear message instead of loading animation
  if (brokerMessage) {
    return (
      <div style={{ fontFamily: "'Segoe UI', sans-serif", background: t.bg, color: t.text, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
        <div style={{ textAlign: 'center', maxWidth: 440, width: '100%', padding: '0 20px' }}>
          <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Market Watch</div>
          <div style={{ color: t.yellow, fontSize: 13, marginTop: 16 }}>{brokerMessage}</div>
          <div style={{ color: t.textMuted, fontSize: 11, marginTop: 8 }}>Use the "Broker Login" button in the navbar to connect a Kite account.</div>
        </div>
      </div>
    );
  }

  return (
    <div style={{ fontFamily: "'Segoe UI', sans-serif", background: t.bg, color: t.text, minHeight: '100vh', display: 'flex', alignItems: 'center', justifyContent: 'center' }}>
      <div style={{ textAlign: 'center', maxWidth: 440, width: '100%', padding: '0 20px' }}>
        <div style={{ fontSize: 20, fontWeight: 700, marginBottom: 4 }}>Market Watch</div>
        <div style={{ color: t.textMuted, fontSize: 13, marginTop: 12 }}>Loading market data...</div>
        <div style={{ marginTop: 16, display: 'flex', justifyContent: 'center', gap: 6 }}>
          {[0,1,2].map(i => (
            <span key={i} style={{
              width: 8, height: 8, borderRadius: '50%', background: t.blue,
              animation: 'pulse 1.2s ease-in-out infinite',
              animationDelay: `${i * 0.2}s`,
              opacity: 0.3,
            }} />
          ))}
        </div>
        <style>{`@keyframes pulse { 0%, 100% { opacity: 0.3; transform: scale(1); } 50% { opacity: 1; transform: scale(1.2); } }`}</style>
      </div>
    </div>
  );
}

export default MarketWatchLoading;
